<template>
  <div id="app">
    <BannerDeAmbiente :ambienteAtual="ambienteAtual" />
    <router-view></router-view>
  </div>
</template>

<script>
import router from "./router";
import BannerDeAmbiente from './components/BannerDeAmbiente';

export default {
  name: "App",
  router,

  data() {
    const ambienteAtual = process.env.VUE_APP_ENV;
    return {
      ambienteAtual,
    };
  },
  components: {
    BannerDeAmbiente,
  },  
};
</script>
